import { useState } from 'react';
import { Link } from 'react-router-dom';
import api, { formatApiError } from '@/lib/api';
import Seo from '@/components/Seo';
import { MailCheck } from 'lucide-react';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError('');
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || 'Something went wrong. Please try again.');
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center p-6 sm:p-12">
      <Seo title="Forgot password" noindex />
      <div className="tm-card p-8 w-full max-w-md space-y-5" data-testid="forgot-password-page">
        {sent ? (
          <div className="text-center space-y-3" data-testid="forgot-sent">
            <MailCheck className="mx-auto text-brand" size={40} />
            <h1 className="font-display font-semibold text-2xl uppercase tracking-tight">Check your inbox</h1>
            <p className="text-sm text-slate-600">If that email is registered, we've sent a link to reset your password. It expires in 1 hour.</p>
            <Link to="/login" className="tm-btn w-full justify-center inline-flex">Back to log in</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-5">
            <h1 className="font-display font-semibold text-3xl uppercase tracking-tight">Forgot password</h1>
            <p className="text-sm text-slate-600 -mt-3">Enter your account email and we'll send you a reset link.</p>
            <div>
              <label className="tm-label">Email</label>
              <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="tm-input" placeholder="you@trade.co.uk" />
            </div>
            {error && <p className="text-sm font-mono text-red-600 bg-red-50 border border-red-600 p-2" data-testid="forgot-error">{error}</p>}
            <button data-testid="forgot-submit" disabled={busy || !email} className="tm-btn w-full">{busy ? 'Sending…' : 'Send reset link'}</button>
            <p className="text-sm text-slate-600">
              Remembered it?{' '}
              <Link to="/login" className="underline underline-offset-4 font-bold text-slate-900 hover:text-brand">Back to log in</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
